import React, {useContext} from "react";
import {WooContext} from "./WooContext";
import DOMPurify from "dompurify";

function PageHeader() {
    const {pageInfoState, filtersLoadedState} = useContext(WooContext);
    const [{databaseId, name, description}] = pageInfoState;
    const [filtersLoaded] = filtersLoadedState;
    function NewlineText(description) {
       const descriptionP = description.split('\n').map(str => {
           if (str !== '\r') { return `<p>${str}</p>`; }
           return '';
       });
        return DOMPurify.sanitize(descriptionP.join(""), {
            USE_PROFILES: { html: true },
        });
    }
     return (
         <div className="woo-header" >
             <h1>{filtersLoaded ? databaseId === 0 ? 'Products' : name||null : <span className="filters-loading">Loading</span> }</h1>
             {filtersLoaded && databaseId === 0 ? 'Showing products based on your search criteria' : description ? <div dangerouslySetInnerHTML={{ __html: NewlineText(description) }}/> : null }
         </div>);
}

export default PageHeader;